import React, { Component, MouseEvent } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { delay } from "@formant/core/common/delay";
import { duration } from "@formant/core/model/duration";
import { IEvent } from "@formant/core/model/IEvent";
import { IEventOrAggregate } from "@formant/core/model/IEventOrAggregate";
import { animate } from "@formant/ui/utils/animate";

import { EventChip } from "../common/EventChip";
import { EventHeadline } from "../common/EventHeadline";
import { EventIcon } from "../common/EventIcon";
import { IconButton } from "../common/IconButton";
import { Linkify } from "../common/Linkify";
import * as styles from "./RecentEvent.scss";

export interface IRecentEventProps {
    event: IEvent;
    onSelect: (event: IEventOrAggregate) => void;
}

@observer
export class RecentEvent extends Component<IRecentEventProps> {
    @observable
    private collapsed: boolean = true;

    public async componentDidMount() {
        await animate();
        this.collapsed = false;
        await delay(5 * duration.second);
        this.collapsed = true;
    }

    public render() {
        const { event } = this.props;
        const { collapsed } = this;

        return (
            <div
                className={classnames(
                    styles["recent-event"],
                    collapsed && styles.collapsed,
                )}
                onClick={this.onSelect}
            >
                <div className={styles.content}>
                    <EventChip event={event} />
                    <EventIcon event={event} />
                    <div className={styles.severity}>
                        <EventHeadline event={event} />
                    </div>
                    <div className={styles.message}>
                        <Linkify text={event.message} />
                    </div>
                    <IconButton
                        icon="close"
                        className={styles.close}
                        onClick={this.onCollapse}
                    />
                </div>
            </div>
        );
    }

    private onSelect = () => {
        const { event } = this.props;
        this.collapsed = true;
        this.props.onSelect({ event });
    };

    private onCollapse = (event: MouseEvent) => {
        event.stopPropagation();
        this.collapsed = true;
    };
}
